// Variant families are declared explicitly, never inferred from product names.
// Single-axis families retain the original members shape. Multi-axis families
// declare their ordered axes and every purchasable combination.
export const VARIANT_FAMILIES = [
  { head: "glp-3", label: "GLP-3", members: ["glp-3", "glp-3-20mg"] },
  { head: "bacteriostatic-water", label: "BAC Water",
    members: ["bacteriostatic-water", "bacteriostatic-water-20ml"] },
  {
    head: "shred-serum-bam15-30ml",
    label: "Shred Serum",
    axes: [
      { name: "Formula", values: ["BAM15", "BAM15 + SR9009"] },
      { name: "Size", values: ["30mL", "60mL", "120mL"] },
    ],
    variants: [
      { values: ["BAM15", "30mL"], id: "shred-serum-bam15-30ml" },
      { values: ["BAM15", "60mL"], id: "shred-serum-bam15-60ml" },
      { values: ["BAM15", "120mL"], id: "shred-serum-bam15-120ml" },
      { values: ["BAM15 + SR9009", "30mL"], id: "shred-serum-combo-30ml" },
      { values: ["BAM15 + SR9009", "60mL"], id: "shred-serum-combo-60ml" },
      { values: ["BAM15 + SR9009", "120mL"], id: "shred-serum-combo-120ml" },
    ],
  },
];

const memberIdsFor = family => family.members || family.variants.map(variant => variant.id);

export const VARIANT_MEMBER_IDS = new Set(
  VARIANT_FAMILIES.flatMap(family => memberIdsFor(family).filter(id => id !== family.head))
);

export const familyFor = id => VARIANT_FAMILIES.find(family => memberIdsFor(family).includes(id));
export const headIdFor = id => (familyFor(id) || { head: id }).head;
export const memberIds = family => memberIdsFor(family);
export const variantForValues = (family, values) =>
  family.variants?.find(variant => variant.values.every((value, index) => value === values[index]));
export const valuesForVariant = (family, id) =>
  family.variants?.find(variant => variant.id === id)?.values;
